import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

const CIHAZ_STORAGE_KEY = 'fikoyt_cihaz_kimlik';
const CIHAZ_CONFIG_KEY = 'fikoyt_cihaz_konfig';
const CIHAZ_DURUM_KEY = 'fikoyt_cihaz_durum';

/**
 * Cihaz Guard — Sadece localStorage kontrolü
 *
 * Guard'ın TEK görevi: localStorage'da cihaz kaydı var mı?
 * - Varsa → geçir (shell polling + Socket.IO ile sunucu doğrulaması yapar)
 * - Yoksa → aktivasyona yönlendir
 *
 * Neden DB sorgusu YOK:
 * - canActivateChild her child navigasyonda tetikleniyor
 * - DB sorgusu başarısız olunca döngü oluşuyordu
 * - Shell zaten 15sn polling + Socket.IO ile durum kontrolü yapıyor
 * - Askıda/iptal gibi durumlar shell tarafından yönetiliyor
 */
export const cihazGuard = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);

  const cihazKimlik = localStorage.getItem(CIHAZ_STORAGE_KEY);
  if (!cihazKimlik) {
    // Federation host'unda hmi-pano remote'u `/hmi-pano` altında mount edilir;
    // aktivasyon route'u da o ağacın kardeşidir. Eski monolit emoji-yol
    // (`/🧩/📟/aktivasyon`) host'ta tanımlı olmadığı için `**`'a düşüp ana
    // sayfaya atıyordu — doğru federation yolu:
    return router.createUrlTree(['/hmi-pano/aktivasyon']);
  }

  // Cihaz kaydı var — geçir
  // Durum kontrolü (aktif/askıda/iptal) shell component tarafından yapılır
  return true;
};

// ═══ Yardımcı fonksiyonlar ═══

export function getAktifCihazKonfig(): any | null {
  const raw = localStorage.getItem(CIHAZ_CONFIG_KEY);
  if (!raw) return null;
  try { return JSON.parse(raw); } catch { return null; }
}

export function setCihazKimlik(kimlik: string): void {
  localStorage.setItem(CIHAZ_STORAGE_KEY, kimlik);
}

export function clearCihazKayit(): void {
  localStorage.removeItem(CIHAZ_STORAGE_KEY);
  localStorage.removeItem(CIHAZ_CONFIG_KEY);
  localStorage.removeItem(CIHAZ_DURUM_KEY);
}

export function getCihazDurum(): string | null {
  return localStorage.getItem(CIHAZ_DURUM_KEY);
}

export function setCihazDurum(durum: string): void {
  localStorage.setItem(CIHAZ_DURUM_KEY, durum);
}
